import { IComponentWithChildren } from '../../../types/app';
import { SimulatorLeftWrapper } from './SimulatorLeft.styled';

const SimulatorLeft: React.FC<IComponentWithChildren> = ({ children }) => {
  return <SimulatorLeftWrapper>{children}</SimulatorLeftWrapper>;
};

export default SimulatorLeft;
